function getTrackingContext($trigger) {
    $trigger = $trigger && $trigger.jquery ? $trigger : $($trigger);

    if (!$trigger || !$trigger.length) {
        return {
            productId: null,
            itemListName: 'plp',
            itemListId: Array.from(document.querySelectorAll('.breadcrumbs-folder')).map(function (el) {
                return el.textContent.trim();
            }).filter(Boolean).join(' | '),
            itemIndex: 0,
            isCarousel: false,
            title: ''
        };
    }

    var $imageTrigger = $trigger.hasClass('js-product-tile-image')
        ? $trigger
        : $trigger.find('.js-product-tile-image').first();
    var $productTile = $trigger.hasClass('product-tile')
        ? $trigger
        : $trigger.closest('.product-tile');
    if (!$imageTrigger.length && $productTile.length) {
        $imageTrigger = $productTile.find('.js-product-tile-image').first();
    }
    var gtmPosition = Number($imageTrigger.data('gtmPosition'));
    var gtmTitle = $imageTrigger.data('gtmTitle');
    var gtmIsCarousel = $imageTrigger.data('gtmIsCarousel') === true || $imageTrigger.data('gtmIsCarousel') === 'true';
    var productId = $imageTrigger.data('productId') || $productTile.data('itemId');
    var searchTerm = $('.suggestions-content input.search-field').val() || $('.search-results-title h1').text().trim() || '';
    var taxonomy = Array.from(document.querySelectorAll('.breadcrumbs-folder')).map(function (el) {
        return el.textContent.trim();
    }).filter(Boolean).join(' | ');
    var itemListName = 'plp';
    var itemListId = taxonomy;

    searchTerm = normalizeSearchTerm(searchTerm);

    if (gtmIsCarousel) {
        itemListName = 'carousel';
        itemListId = gtmTitle || $('.recommendations-title, .pdp-recommendations-title').first().text().trim();
    } else if ($productTile.closest('.suggestions').length > 0) {
        itemListName = 'search_suggestion';
        itemListId = searchTerm ? 'search: ' + searchTerm : 'search';
    } else if ($('.js-product-grid').data('isSearch') === true && searchTerm) {
        itemListName = 'search_page';
        itemListId = 'search: ' + searchTerm;
    }

    return {
        productId: productId,
        itemListName: itemListName,
        itemListId: itemListId,
        itemIndex: Number.isNaN(gtmPosition) ? 0 : gtmPosition,
        isCarousel: gtmIsCarousel,
        title: gtmTitle || itemListId
    };
}

function normalizeSearchTerm(searchTerm) {
    if (!searchTerm) {
        return '';
    }

    if (searchTerm.startsWith('"') || searchTerm.startsWith('“') || searchTerm.startsWith('”')) {
        searchTerm = searchTerm.substring(1);
    }

    if (searchTerm.endsWith('"') || searchTerm.endsWith('“') || searchTerm.endsWith('”')) {
        searchTerm = searchTerm.slice(0, -1);
    }

    return searchTerm.trim();
}

function persistTrackingContext(context) {
    if (!context || !context.productId) {
        return;
    }

    sessionStorage.setItem(`gtmPosition_${context.productId}`, Number.isNaN(context.itemIndex) ? 0 : context.itemIndex);
    sessionStorage.setItem(`gtmTitle_${context.productId}`, context.title || '');
    sessionStorage.setItem(`gtmIsCarousel_${context.productId}`, context.isCarousel ? 'true' : 'false');
    sessionStorage.setItem(`gtmItemListName_${context.productId}`, context.itemListName || '');
    sessionStorage.setItem(`gtmItemListId_${context.productId}`, context.itemListId || '');
    sessionStorage.setItem('gtmLastTitle', context.title || '');
    sessionStorage.setItem('gtmLastIsCarousel', context.isCarousel ? 'true' : 'false');
    sessionStorage.setItem('gtmLastItemListName', context.itemListName || '');
    sessionStorage.setItem('gtmLastItemListId', context.itemListId || '');
    sessionStorage.setItem('gtmLastPosition', Number.isNaN(context.itemIndex) ? 0 : context.itemIndex);
}

module.exports = {
    getTrackingContext: getTrackingContext,
    persistTrackingContext: persistTrackingContext,
    onMouseEnter: function () {
        $('body').on('mouseenter', '.product .tile-can-hover', function () {
            if (!$(this).parent().parent().hasClass('suggestion-section-body'))
                $(this).children().find('.tile-add-to-cart').removeClass('d-md-none');
        });
    },
    onMouseLeave: function () {
        $('body').on('mouseleave', '.product .tile-can-hover', function () {
            $(this).children().find('.tile-add-to-cart').addClass('d-md-none');
        });
    },

    onProductTileClick: function () {
        $('body').on('click', '.product-tile a[href], .product', function () {
            var $productTile = $(this).find('.product-tile');
            persistTrackingContext(getTrackingContext($productTile.length ? $productTile : $(this)));
        });
    }
};
